module.exports = __webpack_public_path__ + "assets/overview-header-decoration.f97e5aa8.png";